import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import supabase from "../../supabase";

const SuccessPaiementArtisan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const checkSession = async () => {
      const params = new URLSearchParams(location.search);
      const sessionId = params.get("session_id");

      if (!sessionId) {
        setSuccessMessage("Merci pour votre paiement !");
        setLoading(false);
        return;
      }

      try {
        // Ici tu pourrais aller chercher des infos de session si besoin (optionnel)
        setSuccessMessage("Merci pour votre paiement ! Votre abonnement a été validé.");
      } catch (error) {
        console.error("Erreur récupération session Stripe :", error);
        setSuccessMessage("Votre paiement a été pris en compte.");
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [location.search]);

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoAccount = () => {
    navigate("/login");
  };

  if (loading) {
    return <div className="text-center mt-5"><p>Chargement...</p></div>;
  }

  return (
    <div className="container text-center mt-5">
      <h2 style={{ color: "#28a745" }}>✅ Paiement Réussi !</h2>
      <p className="mt-3">{successMessage}</p>

      <div className="mt-4">
        <button className="btn btn-success me-3" onClick={handleGoAccount}>
          Accéder à mon compte
        </button>
        <button className="btn btn-outline-primary" onClick={handleGoHome}>
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default SuccessPaiementArtisan;
